<script>
export default {
    name: 'NotFoundPage',
    mounted() {
        this.$store.dispatch('showSiteFooter');
    }
};
</script>

<template>
    <section class="not-found">
        <h1 class="not-found__title">{{ $t('notFound.title') }}</h1>
        <p class="not-found__text">{{ $t('notFound.message') }}</p>
    </section>
</template>

<style lang="scss" scoped>
.not-found {
    @include page;
    text-align: center;
}
.not-found__title {
    font-size: 21rem;
    font-weight: 700;
    color: $color-primary;
    margin: 0;

    @include breakpoint('xs-down') {
        font-size: 12.8rem;
    }
}
.not-found__text {
    font-size: 5rem;
    font-weight: 300;
    color: $color-primary;
    line-height: 1.28;
    max-width: 48rem;
    margin: 0 auto;

    @include breakpoint('xs-down') {
        max-width: 24rem;
        font-size: 2.88rem;
    }
}
</style>
